export default class OrderHistoryDetailTrackingUrl {
	constructor(container) {
		this.container = container;
		this.masterOrderNumber = this.container.dataset.masterOrderNumber;
		this.isFetching = false;
		this.init();
	}

	init() {
		this.container.onclick = this.getTrackingUrlAndNavigate.bind(this);
	}

	async getTrackingUrlAndNavigate({ target }) {
		const { shipmentNumber } = target.dataset;
		if (!shipmentNumber || this.isFetching) return;
		this.setErrorMessageVisibility(true, shipmentNumber);

		try {
			this.isFetching = true;
			const url = `/my-account/order-history/shipment-tracking-url?masterOrderNumber=${this.masterOrderNumber}&shipmentNumber=${shipmentNumber}`;
			const response = await fetch(url);
			const { status, data } = await response.json();
			if (status === 'SUCCESS') this.navigate(data.shipmentTrackingUrl);
			else this.setErrorMessageVisibility(false, shipmentNumber);
			this.isFetching = false;
		} catch (error) {
			this.isFetching = false;
			this.setErrorMessageVisibility(false, shipmentNumber);
			console.error(error); // eslint-disable-line no-console
		}
	}

	navigate(url) {
		window.open(url, '_blank').focus();
	}

	setErrorMessageVisibility(hidden, shipmentNumber) {
		const errorMessage = document.getElementById(
			`trackingUrlErrorMessage-${shipmentNumber}`,
		);
		errorMessage.toggleAttribute('hidden', hidden);
	}
}
